export default __webpack_public_path__ + "static/media/albert-camus.fbef86d8.jpg";